/* eslint-disable jsx-a11y/img-redundant-alt */
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Checkbox, CircularProgress } from "@mui/material";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import InfoIcon from "@mui/icons-material/Info";
import { useState } from "react";
import styles from "../../../../../customer/styles/customerStyles.module.css";
import { useSelector } from "react-redux";
import { orderSelector } from "../../../../../../redux/slices/orderSlice";
import { useEffect } from "react";
import dayjs from "dayjs";
import { getDisputeButtonDesign } from "../../../../../customer/utils/getDIsputeButtonDesign";
import UpdateDisputeModal from "./UpdateDisputeModal";
import DeleteOrderModal from "../../components/DeleteOrderModal";
import DisputeMessagingDrawer from "../../../../../customer/pages/orders/dispute_list/components/DisputeMessagingDrawer";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [openPopMessage, setOpenPopMessage] = React.useState(false);
  const shouldBold = open && { fontWeight: "bold" };

  const popUpMessage = () => {
    setOpenPopMessage(true);
  };
  const popDownMessage = () => {
    setOpenPopMessage(false);
  };

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          borderBottom: "1px solid #ebebeb",
          "&:hover": {
            backgroundColor: "rgba(244,244,244,.5)",
          },
        }}
        onClick={() => setOpen(!open)}
      >
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <Checkbox checked={true} /> : <Checkbox checked={false} />}
          </IconButton>
        </TableCell>
        <TableCell sx={shouldBold}>
          {row?.order?.shopify_order_number || "Not available"}
          <span
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              color: "#FF7E7E",
              position: "relative",
            }}
            onMouseEnter={popUpMessage}
            onMouseLeave={popDownMessage}
          >
            <span>
              {row?.order?.message && <InfoIcon fontSize="extra_samll" />}
            </span>
            {openPopMessage && row?.order?.message && (
              <span
                style={{
                  position: "absolute",
                  zIndex: "99",
                  width: "300px",
                  color: "#212B36",
                  marginTop: "5px",
                  padding: "10px 5px",
                  backgroundColor: "#fff",
                  borderRadius: "10px",
                  boxShadow: "0px 0px 5px 0px rgba(36,36,36,0.75)",
                }}
              >
                <p
                  style={{
                    width: "80%",
                    marginLeft: "10%",
                    fontWeight: "700",
                  }}
                >
                  {row?.order?.message}
                </p>
              </span>
            )}
          </span>
        </TableCell>
        <TableCell sx={shouldBold} style={{ border: "none" }} align="center">
          {row?.issue}
        </TableCell>
        <TableCell sx={{ ...shouldBold, wordBreak: "break-word" }} style={{ border: "none" }} align="center">
          {row?.store?.store_name}
          <h6>{row?.user?.first_name + " " + row?.user?.last_name}</h6>
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {row?.order?.customer_info?.first_name +
            " " +
            row?.order?.customer_info?.last_name}
        </TableCell>
        <TableCell sx={{ ...shouldBold, whiteSpace: "nowrap" }} align="center">
          {dayjs(row?.createdAt).format("YYYY-MM-DD")}
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {getDisputeButtonDesign(row)}
        </TableCell>
        <TableCell align="right">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "4px",
            }}
          >
            <div
              style={{
                opacity:
                  row?.status === "archived" || row?.status === "complete"
                    ? "0.4"
                    : 1,
                pointerEvents:
                  row?.status === "archived" || row?.status === "complete"
                    ? "none"
                    : "",
              }}
            >
              <UpdateDisputeModal disputeId={row?._id} dispute={row} />
            </div>
            <div
              style={{
                opacity:
                  row?.status === "archived" || row?.status === "complete"
                    ? "0.4"
                    : 1,
                pointerEvents:
                  row?.status === "archived" || row?.status === "complete"
                    ? "none"
                    : "",
              }}
            >
              <DeleteOrderModal
                title={row?.issue === "Return to china" ? "Refund for Return (ONLY PRODUCT COST)" :"Refund & Dispute Order"}
                order={row?.order}
                dispute_number={row?.dispute_number}
                type="dispute"
                disputeIssue={row?.issue}
              />
            </div>
            <div
              // style={{
              //   opacity:
              //     row?.status === "archived" || row?.status === "complete"
              //       ? "0.4"
              //       : 1,
              //   pointerEvents:
              //     row?.status === "archived" || row?.status === "complete"
              //       ? "none"
              //       : "",
              // }}
              style={{ marginLeft: "10px", cursor: "pointer" }}
            >
              <DisputeMessagingDrawer dispute={row} />
            </div>
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function DisputeTableCellRemake({ disputeInfo }) {
  const [orderBy, setOrderBy] = useState("ASC");
  const [sortedData, setSortedData] = useState(disputeInfo);
  const [colName, setColName] = useState("");
  const { isLoading } = useSelector(orderSelector);

  // sorting function for each table column
  useEffect(() => {
    setSortedData(disputeInfo);
  }, [disputeInfo]);

  const sorting = (col) => {
    setColName(col);
    if (orderBy === "ASC") {
      const sorted = [...disputeInfo?.disputes].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      );
      setSortedData(sorted);
      setOrderBy("DSC");
    }
    if (orderBy === "DSC") {
      const sorted = [...disputeInfo?.disputes].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      );
      setSortedData(sorted);
      setOrderBy("ASC");
    }
  };
  const tableHeadStyles = {
    color: "#707070",
    fontWeight: 500,
    cursor: "pointer",
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        padding: "1% ",
        width: "100%",
        boxShadow: "none",
        // Fits the page; scrolls sideways only on a narrow window
        overflowX: "auto",
      }}
    >
      <Table
        aria-label="collapsible table"
        size="small"
        sx={{
          "& th, & td": { px: 1.25, py: 1, fontSize: 13 },
          "& th": { whiteSpace: "nowrap" },
        }}
      >
        <TableHead>
          <TableRow
            sx={{
              background: "#eeeeee",
              borderRadius: "0px",
            }}
          >
            <TableCell sx={{ width: "2%" }}></TableCell>
            <TableCell
              align="left"
              sx={tableHeadStyles}
              onClick={() => sorting("orderId")}
            >
              <div
                className={styles.flex_center}
                style={{ justifyContent: "flex-start" }}
              >
                <strong>Order ID</strong>
                {colName === "_id" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell sx={tableHeadStyles} onClick={() => sorting("date")}>
              <div className={styles.flex_center}>
                <strong>Issue</strong>
                {colName === "date" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell sx={tableHeadStyles} onClick={() => sorting("date")}>
              <div className={styles.flex_center}>
                <strong>Store</strong>
                {colName === "date" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              align="left"
              sx={tableHeadStyles}
              onClick={() => sorting("order")}
            >
              <div className={styles.flex_center}>
                <strong>Customer</strong>
                {colName === "order" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell sx={tableHeadStyles} onClick={() => sorting("date")}>
              <div className={styles.flex_center}>
                <strong>Date</strong>
                {colName === "date" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell sx={tableHeadStyles} onClick={() => sorting("status")}>
              <div className={styles.flex_center}>
                <strong>Status</strong>
                {colName === "status" && orderBy === "ASC" ? (
                  <ArrowDownward className={styles.arrow_font} />
                ) : (
                  <ArrowUpward className={styles.arrow_font} />
                )}
              </div>
            </TableCell>
            <TableCell
              sx={tableHeadStyles}
              onClick={() => sorting("status")}
              align="center"
            >
              <strong>Action</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        {!isLoading && (
          <TableBody sx={{}}>
            {sortedData?.map((row) => (
              <Row key={row?._id} row={row} />
            ))}
          </TableBody>
        )}
      </Table>

      {isLoading && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress
            sx={{
              marginTop: "50px",
            }}
            disableShrink
          />
        </div>
      )}
    </TableContainer>
  );
}
